import { render, staticRenderFns } from "./GalleryConfig.vue?vue&type=template&id=0985ef70&scoped=true&"
import script from "./GalleryConfig.vue?vue&type=script&lang=js&"
export * from "./GalleryConfig.vue?vue&type=script&lang=js&"
import style0 from "./GalleryConfig.vue?vue&type=style&index=0&id=0985ef70&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0985ef70",
  null
  
)

export default component.exports